// extracted by mini-css-extract-plugin
export default {"wrapper":"VolumeStatus_wrapper__-30fg","volumeProgress":"VolumeStatus_volumeProgress__jm9Cn","proportions":"VolumeStatus_proportions__DnsU9"};